import React from 'react'

import classNames from 'classnames'
import { Link } from 'react-router-dom'

interface Props extends React.AnchorHTMLAttributes<HTMLAnchorElement> {
  variant?: 'primary' | 'secondary' | 'tertiary' | 'outline' | 'edu'
  size?: 'sm' | 'base' | 'lg'
  external?: boolean
  href: string
  className?: string
}

/**
 * An anchor tag that follows the styling of a button. Use this if you want a button to open a link
 */
const LinkButton: React.FC<Props> = ({
  external,
  href,
  variant,
  size,
  children,
  className,
  ...props
}: Props) => (
  <Link
    to={href}
    className={classNames(`btn ${className}`, {
      'btn-primary': variant === 'primary',
      'btn-secondary': variant === 'secondary',
      'btn-tertiary': variant === 'tertiary',
      'btn-outline': variant === 'outline',
      'btn-edu': variant === 'edu',
      'btn-small': size === 'sm' || variant === 'tertiary',
      'btn-large': size === 'lg',
    })}
    reloadDocument={external}
    {...props}>
    {children}
  </Link>
)

LinkButton.defaultProps = {
  variant: 'primary',
  size: 'base',
  className: '',
}

export default LinkButton
